import React from 'react';
import PropTypes from 'prop-types';
import useSessionManager from '@afosto/auth-react/useSessionManager';
import Alert from '@material-ui/lab/Alert';
import useIntl from '../intl/useIntl';
import Button from '@material-ui/core/Button';

const UnauthorizedComponent = ({ unauthorizedMessage, showActions }) => {
  const intl = useIntl();

  return (
    <Alert
      severity="info"
      action={
        showActions && (
          <Button color="inherit" size="small" onClick={() => window.history.back()}>
            {intl.formatMessage({
              id: 'actions.back',
              defaultMessage: 'Back',
              description: 'label of the back button',
            })}
          </Button>
        )
      }
    >
      {unauthorizedMessage ||
        intl.formatMessage({
          id: 'app.unauthorizedMessage',
          defaultMessage: 'You do not have sufficient permissions for this information.',
          description: "message to show the user when they don't have the correct permissions",
        })}
    </Alert>
  );
};

UnauthorizedComponent.propTypes = {
  unauthorizedMessage: PropTypes.string,
  showActions: PropTypes.bool,
};

UnauthorizedComponent.defaultProps = {
  unauthorizedMessage: undefined,
  showActions: true,
};

export default (permissions = [], unauthorizedMessage) => {
  const sessionManager = useSessionManager();

  const checkPermissions = scopes => {
    if (sessionManager) {
      return sessionManager.hasPermissions(scopes ?? permissions);
    }

    return false;
  };

  return [
    checkPermissions,
    props => <UnauthorizedComponent unauthorizedMessage={unauthorizedMessage} {...props} />,
  ];
};
